module.exports = __webpack_public_path__ + "media/thunk.abda2808.mp3";